import { useState } from "react";
import { Overlay } from "../../../styles/popup";
import * as S from "../styles";

interface RevertProgressConfirmPopupProps {
  onClose: () => void;
  onConfirm: (memo: string) => void;
}

const RevertProgressConfirmPopup = ({
  onClose,
  onConfirm,
}: RevertProgressConfirmPopupProps) => {
  const [memo, setMemo] = useState("");

  const handleConfirm = () => {
    const trimmed = memo.trim();
    if (!trimmed) {
      alert("취소 사유를 입력해 주세요.");
      return;
    }
    onConfirm(trimmed);
    onClose();
  };

  return (
    <Overlay $zIndex={1000}>
      <S.ConfirmPopup>
        <S.ConfirmPopupHeader>
          <div className="title">진행 상태 되돌리기</div>
          <img
            src="/image-web/tournament/close.svg"
            alt="close"
            onClick={onClose}
          />
        </S.ConfirmPopupHeader>

        <S.ConfirmPopupDivider />

        <S.ConfirmPopupBody>
          <p>
            진행 상태를 되돌리면 달성 조건이 해제된 보상이 취소·회수 될 수도
            있습니다.
          </p>
          <S.ConfirmPopupMemoField>
            <label htmlFor="revert-memo">취소 사유</label>
            <textarea
              id="revert-memo"
              name="revert-memo"
              value={memo}
              onChange={(e) => setMemo(e.target.value)}
              placeholder="취소 사유를 입력해 주세요."
              rows={3}
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck={false}
            />
          </S.ConfirmPopupMemoField>
        </S.ConfirmPopupBody>

        <S.ConfirmPopupDivider />

        <S.ConfirmPopupFooter>
          <button type="button" className="cancel" onClick={onClose}>
            취소
          </button>
          <button type="button" className="confirm" onClick={handleConfirm}>
            확인
          </button>
        </S.ConfirmPopupFooter>
      </S.ConfirmPopup>
    </Overlay>
  );
};

export default RevertProgressConfirmPopup;
